import Auth from "./api/AuthAPI";
import Common from "./api/CommonAPI";
import Event from "./api/EventAPI"
import Patient from "./api/PatientAPI"
import Police from "./api/PoliceAPI"
import Circumstances from "./api/CircumstancesAPI"
import Deathreason from "./api/Deathreason"
import Injury from "./api/Injury"
import Hospital from "./api/HospitalAPI"
import Eventform from "./api/EventformAPI"


export default {
   Auth,
   Common,
   Event,
   Patient,
   Police,
   Circumstances,
   Deathreason,
   Injury,
   Hospital,
    Eventform
}
